module.exports = __webpack_public_path__ + "img/2019112002.e47429d1.jpg";